export enum AuthContactActionTypes {
  LoadAllPolicies = '[AuthContact/Page] Load All Policies',
  LoadAllPoliciesSuccess = '[AuthContact/API] Load All Policies Success',
  LoadAllPoliciesFailure = '[AuthContact/API] Load All Policies Failure',
}

export enum AuthApiActionTypes {
  LoginSuccess = '[Auth API] Login Success',
  LoginFailure = '[Auth API] Login Failure',

  SignUpSuccess = '[Auth API] Sign Up Success',
  SignUpFailure = '[Auth API] Sign Up Failure',

  ForgotPasswordSuccess = '[Auth API] Forgot Password Success',
  ForgotPasswordFailure = '[Auth API] Forgot Password Failure',

  TwoFactorAuthSuccess = '[Auth API] Two Factor Auth Success',
  TwoFactorAuthFailure = '[Auth API] Two Factor Auth Failure',

  Resend2faCodeSuccess = '[Auth API] Resend Two Factor Auth Success',
  Resend2faCodeFailure = '[Auth API] Resend Two Factor Auth Failure',

  ResetPasswordSuccess = '[Auth API] Reset Password Success',
  ResetPasswordFailure = '[Auth API] Reset Password Failure',

  SetPasswordSuccess = '[Auth API] Set Password Success',
  SetPasswordFailure = '[Auth API] Set Password Failure',

  ChangePasswordSuccess = '[Auth API] Change Password Success',
  ChangePasswordFailure = '[Auth API] Change Password Failure',

  ContactAuthenticated = '[Auth API] Contact Authenticated',
}
